// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1F5ot","label":"styles_label__25lH6"};